import type { LocalDate, UtcTimestamp } from "../persistence/records";
import type { Clock } from "../../application/ports/clock";

export class BrowserClock implements Clock {
  constructor(
    private readonly timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone,
    private readonly nowProvider: () => Date = () => new Date(),
  ) {}

  dateTime(): Date {
    return new Date(this.nowProvider().getTime());
  }

  now(): UtcTimestamp {
    return this.dateTime().toISOString();
  }

  today(): LocalDate {
    const parts = new Intl.DateTimeFormat("en-US", {
      timeZone: this.timeZone,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    }).formatToParts(this.dateTime());
    const get = (type: Intl.DateTimeFormatPartTypes) => parts.find((part) => part.type === type)?.value;
    const year = get("year");
    const month = get("month");
    const day = get("day");
    if (!year || !month || !day) throw new Error(`Could not determine the date in ${this.timeZone}`);
    return `${year}-${month}-${day}`;
  }
}
